import {
  IScanDestinationZoneData,
  IScanDestinationZoneResponse,
  IScanPodOrTrayCodeErrorResponse,
  TScanDestinationZoneDataOrError,
} from '../../../types';

/**
 * TODO: @renji to pick this up later....
 */
export function formatScanDestinationZoneResponse(
  response: IScanDestinationZoneResponse
): TScanDestinationZoneDataOrError {
  let respData: TScanDestinationZoneDataOrError;

  if ('errorCode' in response) {
    respData = {
      ...(response as IScanPodOrTrayCodeErrorResponse),
      type: 'FAILED',
    };
  }

  respData = {
    // TODO: @renji Fix this type by converting
    ...(response.data as unknown as IScanDestinationZoneData),
    type: 'SUCCESS',
  };

  return respData;
}
